import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import "@volue/stitches-core";
import stitches from "../theme.config.es.js";
const text = stitches.css({
  display: "inline-block",
  fontFamily: "$defaultFont",
  variants: {
    use: {
      strong: {
        fontWeight: "$text-strong"
      },
      subdued: {
        color: "$text-subdued"
      }
    },
    align: {
      center: { display: "block", textAlign: "center" },
      left: { display: "block", textAlign: "left" },
      right: { display: "block", textAlign: "right" }
    }
  }
});
const EzTextStyle = forwardRef(
  ({ as: Text = "span", ...initProps }, ref) => {
    const { props } = text({
      ...initProps,
      align: typeof initProps.align === "object" ? Object.fromEntries(
        Object.entries(initProps.align).map(([key, value]) => [`@${key}`, value])
      ) : initProps.align
    });
    return /* @__PURE__ */ jsx(Text, { ...props, ref });
  }
);
EzTextStyle.displayName = "EzTextStyle";
export {
  EzTextStyle as default
};
//# sourceMappingURL=EzTextStyle.es.js.map
